<template>
  <Modal>
    <div class="modal-header">
      <h4>แก้ไขลิงก์สั้น</h4>
      <button
        @click="onCloseModal"
        class="btn btn-link btm-sm btn-close-container p-0 mr-3">
        <i class="fas fa-times"></i>
      </button>
    </div>
    <div class="modal-body">
      <form v-on:submit.prevent="onSubmit"
        v-if="!saveCustomLinkErrorCode && !isLoadingError">
        <FormGroup :errorMessage="saveCustomLinkErrorState.locationUrl">
          <h5 class="name">ลิงก์</h5>
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text">{{baseURL}}</span>
              </div>
              <input
                type="text"
                placeholder="เช่น knowledgePool"
                class="form-control"
                :class="{'is-invalid': saveCustomLinkErrorState.locationUrl}"
                v-model="customLink.locationUrl"
                @blur="checkUrlValid" />
              <div class="invalid-feedback"
                v-if="saveCustomLinkErrorState.locationUrl">
                {{saveCustomLinkErrorState.locationUrl}}
              </div>
            </div>
        </FormGroup>
        <FormGroup :errorMessage="saveCustomLinkErrorState.redirectUrl">
          <h5 class="name">ลิงก์ปลายทาง</h5>
          <input
            type="text"
            placeholder="เช่น https://www.altv.tv/programs/knowledge-pool/5efd9f9472e08c08eb7b4664?type=episode"
            class="form-control"
            :class="{'is-invalid': saveCustomLinkErrorState.redirectUrl}"
            v-model="customLink.redirectUrl"
            @blur="checkTargetUrlValid" />
          <div class="invalid-feedback"
            v-if="saveCustomLinkErrorState.redirectUrl">
            {{saveCustomLinkErrorState.redirectUrl}}
          </div>
        </FormGroup>
        <FormGroup
          class="with-help-text"
          :errorMessage="saveCustomLinkErrorState.title">
          <h5 class="name">ชื่อลิงก์</h5>
          <input
            type="text"
            placeholder="เช่น รายการสารคดีความรู้"
            class="form-control"
            :class="{'is-invalid': saveCustomLinkErrorState.title}"
            v-model="customLink.title" />
          <div class="invalid-feedback"
            v-if="saveCustomLinkErrorState.title">
            {{saveCustomLinkErrorState.title}}
          </div>
        </FormGroup>
        <div class="form-action">
          <button
            :disabled="!isValid"
            type="submit"
            class="btn btn-primary btn-create">
            <span v-if="!saveCustomLinkState.isSaving">แก้ไขลิ้งก์</span>
            <span v-if="saveCustomLinkState.isSaving">กำลังแก้ลิงก์...</span>
          </button>
        </div>
      </form>
      <EmptyMessage v-if="saveCustomLinkErrorCode">
        <h3>เกิดข้อผิดพลาดขณะบันทึก</h3>
        <router-link
          :to="`/custom-links`"
          class="btn btn-light btn-lg mt-4">
          กลับสู่หน้าลิ้งก์
        </router-link>
        <span
          slot="code"
          class="code">
          Code : {{saveCustomLinkErrorCode || 'not found' }}
        </span>
      </EmptyMessage>
      <EmptyMessage v-if="isLoadingError">
        <h3>เกิดข้อผิดพลาดขณะกำลังโหลดข้อมูล</h3>
        <router-link
          :to="`/custom-links`"
          class="btn btn-light btn-lg mt-4">
          กลับสู่หน้าลิ้งก์
        </router-link>
        <span
          slot="code"
          class="code">
          Code : {{loadingErrorCode || 'not found' }}
        </span>
      </EmptyMessage>
    </div>
  </Modal>
</template>

<script>
/* eslint max-len: ["off"] */
import _ from 'lodash';
import { updateCustomLinkById, loadCustomLinkById } from '@/customLinks/api';
import Modal from '@/components/Modal.vue';
import FormGroup from '@/components/FormGroup.vue';
import EmptyMessage from '@/components/EmptyMessage.vue';

export default {
  components: {
    Modal,
    FormGroup,
    EmptyMessage,
  },
  data() {
    return {
      saveCustomLinkErrorCode: null,
      customLink: {
        title: null,
        locationUrl: null,
        redirectUrl: null,
      },
      saveCustomLinkErrorState: {
        title: null,
        locationUrl: null,
        redirectUrl: null,
      },
      saveCustomLinkState: {
        isSaving: false,
        isSaved: false,
      },
      state: {
        isLoading: false,
        isError: false,
        errorCode: null,
      },
    };
  },
  computed: {
    baseURL() {
      const env = process.env.NODE_ENV;
      if (env === 'production') {
        return 'https://altv.tv';
      }
      return process.env.VUE_APP_BASEURL || window.location.origin;
    },
    isValid() {
      if (!this.saveCustomLinkState.isSaving) {
        return this.customLink.locationUrl && this.customLink.redirectUrl && !this.haveErrorMessage;
      }
      return false;
    },
    isLoadingError() {
      return this.state.isError;
    },
    haveErrorMessage() {
      return _.some(this.saveCustomLinkErrorState, (value) => value);
    },
    customLinkId() {
      return this.$route.params.id;
    },
    combinedURL() {
      return `${this.baseURL}/${this.customLink.locationUrl}`;
    },
  },
  created() {
    this.load();
  },
  methods: {
    async load() {
      this.state.isLoading = true;
      try {
        const response = await loadCustomLinkById(this.customLinkId);
        this.state.isLoading = false;
        this.state.isError = false;
        this.customLink = response.data;
      } catch (error) {
        this.state.isLoading = false;
        this.state.isError = true;
        this.state.errorCode = _.get(error, 'response.status', null);
      }
    },
    async onSubmit() {
      this.saveCustomLinkErrorCode = null;
      this.saveCustomLinkErrorState = { title: null, locationUrl: null, redirectUrl: null };
      this.saveCustomLinkState.isSaving = true;
      try {
        await updateCustomLinkById(this.customLinkId, this.customLink);
        this.saveCustomLinkState.isSaving = false;
        this.saveCustomLinkState.isSaved = true;
        this.onCloseModal();
      } catch (error) {
        this.saveCustomLinkState.isSaving = false;
        this.saveCustomLinkErrorCode = _.get(error, 'response.status', null);
        if (this.saveCustomLinkErrorCode === 422) {
          this.saveCustomLinkErrorState.title = 'กรุณาระบุชื่อลิงก์';
          this.saveCustomLinkErrorState.locationUrl = 'กรุณาระบุลิงก์สั้น';
          this.saveCustomLinkErrorState.redirectUrl = 'กรุณาระบุลิงก์ปลายทาง';
        } else {
          this.saveCustomLinkErrorState.title = 'เกิดข้อผิดพลาดขณะบันทึก';
          this.saveCustomLinkErrorState.locationUrl = 'เกิดข้อผิดพลาดขณะบันทึก';
        }
      }
    },
    checkUrlValid(event) {
      const value = _.get(event, 'target.value', null);
      if (!value) {
        this.saveCustomLinkErrorState.locationUrl = 'กรุณากรอกข้อมูล';
      } else {
        this.saveCustomLinkErrorState.locationUrl = null;
      }
    },
    checkTargetUrlValid(event) {
      const value = _.get(event, 'target.value', null);
      if (!this.isValidURL(value)) {
        this.saveCustomLinkErrorState.redirectUrl = 'กรุณาตรวจสอบความถูกต้องของลิงก์';
      } else {
        this.saveCustomLinkErrorState.redirectUrl = null;
      }
    },
    onCloseModal() {
      this.$router.back();
    },
    isValidURL(str) {
      const httpregexp = /http|https/;
      const regexp = /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;
      if (httpregexp.test(str)) {
        if (regexp.test(str)) {
          return true;
        }
        return false;
      }
      return false;
    },

  },
};
</script>

<style lang="scss" scoped>

.form-action {
  display: flex;
  .btn-create {
    margin-left: auto;
  }
}
.darker-readonly {
  background: #021b31;
}
</style>
